import request from '@/utils/request'

// 分页获取收款计划列表
export function getCollectionPlanPage(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/receipt-plan/page',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增收款计划
export function saveCollectionPlan(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/receipt-plan/save',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除收款计划
export function deleteCollectionPlan(id) {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/receipt-plan/delete/${id}`,
      method: 'delete'
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取收款计划详情
export function getCollectionPlanDetail(id) {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/receipt-plan/get/${id}`,
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增收款记录
export function saveReceiptRecord(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/receipt-record/save',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新收款计划
export function updateCollectionPlan(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/api/receipt-plan/update',
      method: 'put',
      data: params
    }).then(response => {
      const res = response.data
      resolve({
        code: res.code,
        data: res.data,
        message: res.message
      })
    }).catch(error => {
      reject(error)
    })
  })
}
